
$('#drawer a[href^="/#"]').on('click', function() {
	$("#drawer").removeClass("open");
	$("#overlay").removeClass("open");
	$('body').removeClass('open');
});

// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
 		}  else {
  		sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
 		}
	}
	 window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("footer_to_top_btn") != null){
const pagetopBtn = document.querySelector('#footer_to_top_btn');
pagetopBtn.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
});
};



// サイドTOPに戻る
if(document.getElementById("side_to_top_btn") != null){
const pagetopBtn_side = document.querySelector('#side_to_top_btn');
pagetopBtn_side.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
});

const pagetopBtn_side_sp = document.querySelector('#side_to_top_btn_sp');
pagetopBtn_side_sp.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		behavior: "smooth"
	});
});

$(function() {
	let side_pageTop_Animation = function() {
	//アイコン位置取得
	let side_pageTop =  document.getElementById('side_to_top_btn_sec');
	let fixed_br =  document.getElementById('fixed_br');
	//フッター位置取得
	let footer_position_mark =  document.getElementById('footer_position_mark');
 
	//要素の位置座標を取得
	let rect_side_pageTop = side_pageTop.getBoundingClientRect();
	//フッターの位置座標を取得
	let rect_footer_position_mark = footer_position_mark.getBoundingClientRect();

	//topからの距離
	let side_pageTop_scrollTop = rect_side_pageTop.top + window.pageYOffset;
	let rect_footer_position_mark_scrollTop = rect_footer_position_mark.top + window.pageYOffset;

	if(side_pageTop_scrollTop > 900 && side_pageTop_scrollTop < rect_footer_position_mark_scrollTop){
	  side_pageTop.classList.add('show');
	  fixed_br.classList.add('show');
	 }  else {
	  side_pageTop.classList.remove('show');
	  fixed_br.classList.remove('show');
	 }
   }
	  window.addEventListener('scroll', side_pageTop_Animation);
	});


};

